import { useContext } from 'react';

import { NewbuildingBrokerWidgetContext } from './NewbuildingBrokerWidgetContext';

export const useNewbuildingBrokerContext = () => useContext(NewbuildingBrokerWidgetContext);
